export default {
  user: state => state.user,
  organisation: state => state.organisation,
  organisations: state => state.organisations,
  invites: state => state.invites,
  wallet: state => state.wallet,
  switch_key: state => state.switch_key
};
